/**
 * Suche nach Rezepten. Dieselbe Ansicht wie die Übersicht, nur mit
 * Schwerpunkt auf dem Suchfeld.
 */
import { RecipeBrowser } from '../components/RecipeBrowser.tsx';
import { texts } from '../texts/de.ts';

/** Seite für die Suche. */
export function SearchPage() {
  return (
    <RecipeBrowser
      mode="search"
      title={texts.nav.search}
      subtitle="Nach Name, Zutat, Schlagwort oder Kategorie suchen."
    />
  );
}
